export default __webpack_public_path__ + "static/media/mist.b8929a60.mp4";